import { EditableContent } from '../../edit/EditableContent';
import { LucideIcon } from '../../icons/LucideIcon';
import { resolveSectionLucideIcon } from '../../icons/ctaLucideMap';
import { pickBlockField } from '../../lib/localized';
import type { BlockRenderProps } from '../../types';

export function StaticLocationText({
  block,
  locale,
  isActive,
  activeEditTarget,
  editable,
}: BlockRenderProps) {
  const sectionTitle = pickBlockField(block.content, 'sectionTitle', locale);
  const sectionIconKey = pickBlockField(block.content, 'sectionIcon', locale);
  const locationLabel = pickBlockField(block.content, 'locationLabel', locale);
  const address = pickBlockField(block.content, 'address', locale);
  const directions = pickBlockField(block.content, 'directions', locale);
  const hours = pickBlockField(block.content, 'hours', locale);
  const target = isActive ? activeEditTarget : null;
  const sectionIcon = resolveSectionLucideIcon(sectionIconKey, 'location');

  return (
    <section
      className={['ws-static-location', isActive ? 'ws-block--active' : '']
        .filter(Boolean)
        .join(' ')}
      data-block-id={block.blockId}
      data-component={block.componentType}
      id="location"
    >
      <div className="ws-static-location__inner">
        <div className="ws-static-location__header">
          <EditableContent
            as="span"
            fieldKey="sectionIcon"
            editable={editable}
            activeEditTarget={target}
            className="ws-static-location__icon-hit"
          >
            <LucideIcon icon={sectionIcon} size="md" className="ws-static-location__icon" />
          </EditableContent>
          <EditableContent
            as="h2"
            fieldKey="sectionTitle"
            editable={editable}
            activeEditTarget={target}
            className="ws-static-location__title"
          >
            {sectionTitle}
          </EditableContent>
        </div>
        {locationLabel || editable ? (
          <EditableContent
            fieldKey="locationLabel"
            editable={editable}
            activeEditTarget={target}
            className="ws-static-location__label"
          >
            {locationLabel}
          </EditableContent>
        ) : null}
        <EditableContent
          fieldKey="address"
          editable={editable}
          activeEditTarget={target}
          className="ws-static-location__address"
        >
          {address}
        </EditableContent>
        {hours || editable ? (
          <EditableContent
            fieldKey="hours"
            editable={editable}
            activeEditTarget={target}
            className="ws-static-location__hours"
          >
            {hours}
          </EditableContent>
        ) : null}
        {directions || editable ? (
          <EditableContent
            fieldKey="directions"
            editable={editable}
            activeEditTarget={target}
            className="ws-static-location__directions"
          >
            {directions}
          </EditableContent>
        ) : null}
      </div>
    </section>
  );
}
